import Cookies from 'js-cookie';

// Capitalize
export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Format price
export function formatPrice(number) {
  const fnumber = parseFloat(number);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(fnumber);
}

export function parseJwt(token) {
  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
}

// cookies session

export const logOut = () => {
  Cookies.remove('__session');
};

export const loadState = () => {
  try {
    return Cookies.get('__session') ? JSON.parse(Cookies.get('__session')) : {};
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const saveState = (state) => {
  try {
    // TODO: encrypt data
    Cookies.set('__session', state, { expires: 2 });
  } catch (error) {
    console.log(error);
  }
};

export const deleteCookie = () => {
  try {
    Cookies.remove('__session');
  } catch (error) {
    console.log(error);
  }
};

// filter object for charts updates
export const filterObject = (value) => {
  if (value == null) {
    return null;
  }
  return {
    active: true,
    restrictionColumn: ['date'],
    restrictionColumnDatatype: ['date'],
    restrictionColumnFormat: ['%d/%m/%y'],
    restrictionColumnToValue: [value],
    restrictionColumnSign: ['<=']
  };
};

export const initialOutputs = {
  add_back_histo_imp_gw_intangible: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  adj_ebitda_net_interest: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cap_increase: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cap_reduction: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  capex_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_beginning: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_cash_eq: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_end: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_roce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cfff: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cffi: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cffo: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  change_cash: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  change_y_y: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  deferred_tax_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  depr_amort: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  depr_amort_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  div_fcf_equity: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  div_paid: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebita_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda_cagr: {
    '_1-5': '',
    '_2-5': ''
  },
  ebitda_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  equity_ex_mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  goodwill: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_gw_other_intangible: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  group_revenues: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_exp: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_invest_income: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_rate: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  invest_sub_asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  liab_held_sale: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_adj_ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_adj_ebitda_capex: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_equity: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_equity_net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_income: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_income_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_interest: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ntce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc_change: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  o_w_depr_amort_charge: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  o_w_tax_paid: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  op_cash_flow: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  operating_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  operating_profit_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_cfff: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_cffi: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pbt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pbt_op_cash_adj: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pension_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  profit_loss_mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  provisions: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  revenues_cagr: {
    '_1-5': null,
    '_2-5': null
  },
  revenues_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  roce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  roe: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  share_profit_loss_asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tangible_fixed: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tax_charge: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tax_rate: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_assets: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_capex: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_unusual: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  unlevered_fcf_ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  unlevered_fcf_op_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  }
};
